import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Col, Row } from 'reactstrap';
import useFilter from '../hooks/useFilter';
import useAxiosPrivate from '../hooks/useAxiosPrivate';

export default function CourseStatuses() {
    const { filter } = useFilter();
    const axiosPrivate = useAxiosPrivate();
    const [loading, setLoading] = useState(true);
    const [selectAll, setSelectAll] = useState(true);

    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [customSelectedStatuses, setCustomSelectedStatuses] = useState([]);
    const [courseStatuses, setCourseStatuses] = useState([]);

    useEffect(() => {
        const getCourseStatuses = async () => {
            if (filter?.formCourseStatuses) {
                setCourseStatuses(filter.formCourseStatuses);
                if (filter?.formSelectAllCourseStatuses) {
                    setSelectAll(true);
                    setSelectedStatuses(filter.formCourseStatuses)
                }
                else {
                    setSelectAll(false);
                    var selected = filter?.formCourseStatuses.filter(courseType => filter?.courseStatuses.includes(courseType.value))
                    setCustomSelectedStatuses(selected);
                    setSelectedStatuses(selected);
                }
            }
            else {
                var courseStatusesList = [
                    //{ value: -2, label: "Waiting Users" },
                    //{ value: -1, label: "Subscriptions To Confirm" },
                    { value: 0, label: "Subscribed" },
                    { value: 1, label: "In Progress" },
                    { value: 2, label: "Completed" },
                    //{ value: 3, label: "Suspended" },
                    //{ value: 4, label: "Overbooking" },
                ];
                setCourseStatuses(courseStatusesList);
                setSelectedStatuses(courseStatusesList);
            }
        };

        Promise.all([getCourseStatuses()]).then(function () {
            setLoading(false);
        });
    }, []);

    const onSelectAllChange = (value) => {
        setSelectAll(value);
        if (value === true) {
            setSelectedStatuses(courseStatuses);
        }
        else {
            setSelectedStatuses(customSelectedStatuses);
        }
    };

    const onSelectedStatusesChange = (value) => {
        setCustomSelectedStatuses(value);
        setSelectedStatuses(value);
    };

    const sortOptions = (options) => {
        return options.sort((a, b) => a.label.localeCompare(b.label));
    }
    return ({
        loading, selectAll, selectedStatuses, courseStatuses,
        render:
            <Row>
                <Col xs="6">
                    <h5>Course Statuses</h5>
                </Col>
                <Col xs="6">
                    <div>
                        <input className='radio-margin' type='radio' name='courseStatusesRadio' onChange={() => onSelectAllChange(true)} checked={selectAll} /> Select All
                        <input className='radio-margin' type='radio' name='courseStatusesRadio' onChange={() => onSelectAllChange(false)} checked={!selectAll} /> Custom Selection
                    </div>
                    <div>
                        {!selectAll ?
                            <div>
                                <label>Statuses</label>
                                <Select isMulti value={selectedStatuses} options={sortOptions(courseStatuses)} onChange={onSelectedStatusesChange} />
                            </div>
                            : null}
                    </div>
                </Col>
            </Row>
    });
}